
import { defineComponent } from 'vue'
import BuiltinLoginForm from '@/components/organisms/BuiltinLoginForm.vue'
export default defineComponent({
  components: {
    BuiltinLoginForm
  }
})
